import React, { useRef,useState,useEffect } from 'react';
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Link } from "gatsby";
import { Helmet } from "react-helmet";
import ScrollAnimation from 'react-animate-on-scroll'; 
import { isIOS } from 'react-device-detect';
import PlayVideo from '../PlayVideo/PlayVideo';
import "./AboutUs.scss";
import { GetURL } from '../utils';
import HTMLReactParser from 'html-react-parser';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import ContactCard from "../ContactCard/ContactCard";
import $ from "jquery";
import ContactFormPage from '../forms/contact';

const AboutUs = (props) => {
    const [isPlaying, setPlaying] = useState(false); 
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState('');

    function fullScreenHandler() {
        var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
        if(fullscreenElement == null) {
            setPlaying(false);
        }
    }

    React.useEffect(() => {
        document.addEventListener("fullscreenchange", fullScreenHandler, false);
        document.addEventListener("webkitfullscreenchange", fullScreenHandler, false);
        document.addEventListener("MSFullscreenChange", fullScreenHandler, false);
        document.addEventListener("mozfullscreenchange", fullScreenHandler, false);
        $(".email").on("click", (e) => {
            let email = e.currentTarget.innerText;
            setEmail(email);
            setShow(true);
        })
    }, []);
    const [renderComponent, setRenderComponent] = useState(false);
    useEffect(() => {
        if (isIOS) {
          setRenderComponent(true)
        }else {
        window.addEventListener("mousemove", () => {
        if (renderComponent === false) {
          setRenderComponent(true)
        }
        })
        window.addEventListener("touchmove", () => {
            if (renderComponent === false) {
            setRenderComponent(true)
            }
        })
        window.addEventListener("keypress", () => {
            if (renderComponent === false) {
            setRenderComponent(true)
            }
        })}
    }, [])

    return (
        <React.Fragment>
             <Helmet>
                       <meta name="robots" content="index, follow" />
                       </Helmet>
            <section className="about-section">
                <Container>
                    <Row className="client-wrapper">
                        <Col lg={6} className="message-wrap">
                            <ScrollAnimation animateIn="fadeInUp">
                                <div className="ltl-block contact-home-block">
                                    <span className="text">{props?.data?.Title}</span>
                                    {props?.data?.Content && <p className="rm-margin">{HTMLReactParser(props?.data?.Content?.replaceAll("\n", "<br/>"))}</p>}
                                    {props?.data?.Select_Team_Member && <div className="testimonial-wrapper d-flex">
                                        <ContactCard
                                                blockImg={props?.data?.Select_Team_Member?.Tile_Image?.url}
                                                blockTitle={props?.data?.Select_Team_Member?.Name}
                                                blockContent={`We are the Kensington and Chelsea garden square specialists. Interested in selling or letting, get in touch with our team.`}
                                                blockBtn="Speak to our team"
                                                blockLink={props?.data?.Contact_Link ? GetURL(props?.data?.Contact_Link?._id) : `/about/meet-the-team/${props?.data?.Select_Team_Member?.Url}/`}
                                                blockVideo={props?.data?.Select_Team_Member?.Video_Url} 
                                            />
                                        {/* <div className="testimonial">
                                            {/* <img 
                                                src={props?.data?.Select_Team_Member?.Tile_Image?.url} 
                                                alt={props?.data?.Select_Team_Member?.Tile_Image?.url}
                                            /> */}
                                            {/* <GatsbyImage
                                                loading='lazy'
                                                image={getImage(props?.data?.Select_Team_Member?.Tile_Image?.url_sharp)}
                                                alt={props?.data?.Select_Team_Member?.Name + " " + props?.data?.Select_Team_Member?.Designation + "- tlc Estate Agents"} 
                                            />
                                            <i  
                                                className="video-icon" 
                                                onClick={(e) => {
                                                    setPlaying(true);
                                                }}
                                            />
                                        </div> */} 
                                        {/* <div className="director-detail">
                                            <div className="signature">
                                                {renderComponent &&
                                                    <>
                                                    // {props?.data?.Select_Team_Member?.Signature?.url &&
                                                    //     <img src={props?.data?.Select_Team_Member?.Signature?.url} alt={props?.data?.Select_Team_Member?.Signature?.alternativeText ? props?.data?.Select_Team_Member?.Signature?.alternativeText : props?.data?.Select_Team_Member?.Name} 
                                                    //     loading="lazy" width={170} height={53}  />
                                                    // }
                                                    </>
                                                }

                                            </div>
                                            <span className="director-name">
                                                {props?.data?.Select_Team_Member?.Name} – {props?.data?.Select_Team_Member?.Designation}
                                            </span>
                                        </div> */}
                                    </div>}
                                </div>
                            </ScrollAnimation>
                        </Col>
                        <Col lg={6} className="achievement-wrap">
                            <ScrollAnimation animateIn="fadeInUp">
                                <div className="rtl-block">
                                    <span className="text">{props?.data?.List_Title}</span>
                                    <div className="About-wrap">
                                        {props?.data?.List_Component.map((item, k) => (
                                            <Link to={GetURL(item?.List_Link?._id)} className="story-wrapper d-flex about-story" key={k}>
                                                <div className="img-wrap">
                                                    <GatsbyImage
                                                        loading='lazy'
                                                        image={getImage(item?.Tile_Image?.url_sharp_sm)}
                                                        alt={item?.Tile_Image?.alternativeText ? item?.Tile_Image?.alternativeText : props?.data?.List_Title + "- tlc Estate Agents"} 
                                                    />
                                                </div>
                                                <div className="our-img d-flex align-items-center justify-content-between">
                                                    <span className="story">{item.Title}</span>
                                                    <i className="circle-arrow"></i>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </Col>
                    </Row>
                </Container>
            </section>
            {(props?.data?.Select_Team_Member?.Video_Url && isPlaying) && <div>
                {isPlaying &&
                    <React.Fragment>
                        <PlayVideo
                            isOpen={isPlaying}
                            videoId={props?.data?.Select_Team_Member?.Video_Url}
                            stopPlay={setPlaying}
                            width={'100%'} height={'100%'}
                            fullscreen={true}
                        />
                    </React.Fragment>
                }
            </div>}
            <Modal className="form-popup" onHide={() => setShow(false)} show={show} contentClassName="p-0" size="sm">
                <Modal.Body className="p-5">
                    <button onClick={() => setShow(false)} type="button" className="close-modal">
                        <i className="icon-close-modal"></i>
                    </button> 
                    <div className="form-block career-form">
                        <ContactFormPage email={email}/>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default AboutUs;
